var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":"","placeholder":_vm.$l('common.select','请选择')},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.value,attrs:{"value":item.value,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }